import bg1 from "../../assets/img/bg1.jpg";
import bg2 from "../../assets/img/bg2.jpg";
import bg3 from "../../assets/img/bg3.jpg";

export const images = [
  {
    title: "Fashion Collection 2021",
    subtitle: "Collection 2021",
    buttonContent: "Learn More",
    img: bg1,
  },
  {
    title: "Fresh Collection 2021",
    subtitle: "Collection 2021",
    buttonContent: "Learn More",
    img: bg2,
  },
  {
    title: "Classic Collection 2021",
    subtitle: "Collection 2021",
    buttonContent: "Learn More",
    img: bg3,
  },
];
